import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter } from "@nextui-org/react";
import { ZButton } from "@/shared/components/button";
import { Questionnaire } from "../../requests/questionnaire";

interface QuestionnaireConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  questionnaire: Questionnaire | null;
  isLoading?: boolean;
}

const QuestionnaireConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  questionnaire,
  isLoading = false
}: QuestionnaireConfirmationModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      classNames={{
        wrapper: "z-[9999]",
        backdrop: "bg-black/50"
      }}
    >
      <ModalContent className="py-4">
        <ModalHeader className="flex flex-col gap-1 px-6 pb-2 items-center">
          <h3 className="text-lg font-semibold text-gray-900 text-center leading-tight">
            Are You Sure You Want to Permanently Remove {questionnaire?.questionnaire_name}?
          </h3>
        </ModalHeader>
        <ModalBody className="px-6 py-2 items-center">
          <p className="text-sm text-gray-600 text-center">
            All existing sessions using this Questionnaire and Document Set will continue to have access to these questions.
          </p>
        </ModalBody>
        <ModalFooter className="px-6 pt-4">
          <ZButton
            variant="bordered"
            onClick={onClose}
            className="flex-1"
            isDisabled={isLoading}
          >
            Cancel
          </ZButton>
          <ZButton
            color="danger"
            onClick={onConfirm}
            className="flex-1"
            isLoading={isLoading}
            isDisabled={isLoading}
          >
            Yes, Delete
          </ZButton>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default QuestionnaireConfirmationModal;